import PropTypes from "prop-types";
import React from "react";

import SmartyAutoComplete from "../../../provider-management/components/fields/address-field/SmartyAutoComplete";
import CustomTextField from "../../../provider-management/components/fields/CustomTextField";
import FieldLabel from "../../../provider-management/components/provider-details/FieldLabel";
import { STYLES } from "../../../provider-management/utils/customStyles";

import { getDisplayAddressText } from "./primarySectionUtils";

const TEXT_FIELDS = [
  { fieldName: "email", label: "Email", placeholder: "Please enter a valid email" },
  { fieldName: "phone", label: "Phone", placeholder: "Please enter a phone number" },
  { fieldName: "homepage", label: "Homepage", placeholder: "Please enter website URL" },
];

export default function PrimaryTextFields({ formState, isEditing, onChange }) {
  return (
    <>
      <div className="grid gap-4 md:grid-cols-3">
        {TEXT_FIELDS.map(({ fieldName, label, placeholder }) => (
          <div key={fieldName} className="flex flex-col gap-2">
            <FieldLabel value={label} />
            <CustomTextField
              fieldName={fieldName}
              fieldValue={formState[fieldName]}
              onChange={onChange}
              readOnly={!isEditing}
              noClearIcon={!isEditing}
              placeholder={placeholder}
            />
          </div>
        ))}
      </div>

      <div className="grid gap-2">
        {!isEditing ? <FieldLabel value="Address" /> : null}
        {isEditing ? (
          <SmartyAutoComplete
            address={formState.address}
            setAddress={(value) => onChange("address", value)}
            primaryFieldLabel="Street"
            hideLabel={true}
            inputSx={STYLES.textField}
          />
        ) : (
          <CustomTextField
            fieldName="address"
            fieldValue={getDisplayAddressText(formState.address)}
            onChange={onChange}
            readOnly={true}
            noClearIcon={true}
            placeholder="Please enter address"
          />
        )}
      </div>
    </>
  );
}

PrimaryTextFields.propTypes = {
  formState: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
